export const iconFontAwesomeTravelHotelTrainTram = (
	<i className="fa-solid fa-train-tram"></i>
);
